export default {
  // 语言选项
  lang: {
    zh: '简体中文',
    en: 'English',
    de: 'Deutsch',
  },

  // 导航
  nav: {
    home: '首页',
    marketArea: '市场领域',
    productCenter: '产品中心',
    serviceSupport: '服务与支持',
    news: '新闻中心',
    contactUs: '联系我们',
  },

  // 页脚
  footer: {
    followUs: '关注联系我们',
    email: '邮箱：info-am@melonbean.com',
    address: '地址：广东省中山市火炬开发区街道东利南路5号',
    home: '首页',
    marketArea: '市场领域',
    productCenter: '产品中心',
    serviceSupport: '服务与支持',
    contactUs: '联系我们',
    market: {
      chemical: '化工',
      spaceflight: '航天',
      electron: '电子',
      AI: 'AI',
      transportation: '交通',
      newEnergy: '新能源',
      architecture: '建筑',
      homeAppliances: '家电',
    },
    product: {
      heatConduction: '热界面材料',
      heatInsulation: '纳米板',
      thermalInsulation: '保温隔热材料',
      fireproof: '防火/耐高温涂层',
      insulation: '超薄隔热材料',
      electricHeating: '电发热材料',
      dielectric: '绝缘材料',
      electricConduction: '导电材料',
    },
    contact: {
      contactInfo: '联系方式',
      companyAddress: '公司地址',
      joinUs: '加入我们',
    },
    copyright: '© 2025 梅隆比恩创新材料有限公司 版权所有 | 粤ICP备XXXX号',
  },

  // 首页
  home: {
    bannerTitle: '用材料创造美好生活',
    bannerSubtitle: 'Create a better life with materials',
    companyTitle: '公司简介',
    companyIntro: '梅隆比恩（德国）创新材料有限公司成立于2019年1月份，在全球设有不同的分支机构，研发总部在德国，中国有着当地的研发中心，公司致力于热电管理创新型材料的开发和应用，可应用在保温，隔热，蓄热，导热，电发热，防火，绝缘，导电，放静电等材料的整理解决方案，公司采用垂直化研发，从原材料到终端应用的全流程整合，以对材料的全面了解去满足客户的需求，更加贴切的满足客户的应用，同时与欧美很多公司共享研发相关的成果。',
    companyIntro2:"",
    culture: '企业文化',
    mission: '使命',
    missionInfo: '用材料创造美好生活',
    vision: '愿景',
    visionInfo: '成为热电管理功能性材料市场的优先合作伙伴',
    value: '价值观',
    valueInfo: '实事求是',
    productTitle: '产品介绍',
    viewAll: '查看全部 →',
    moreInfo: '更多信息',
    solutionTitle: '解决方案',
    newsTitle: '新闻中心',
    news: {
      article1: '导热系数为0.028的保温隔热涂料为国内大客户所采用。',
      article2: '防火保温涂料被航空客户用到油箱防护上。',
      article3: '导热相变材料批量用于服务器/AI设备上。',
      article4: '耐高温保温隔热材料用到柴油发动机涡轮增压部位保温隔热。',
      article5: '导热垫片3W&5W批量用于服务器上。',

    },
    products: {
      fireproof: {
        title: '防火涂料',
        content: '以有机无机杂化硅合树脂为主体的耐高温涂层，具有优异的耐高温性能。加上合适的填料，可以做到最高短时间耐温超过2000摄氏度，长时间工作温度650摄氏度。',
      },
      thermalInsulation: {
        title: '保温涂料',
        content: '保温隔热涂料主要通过喷涂的方式施工到需要保温隔热的基材上，包括金属，无机，塑料等，尤其适合异型位置。保温隔热涂料具有最低为0.025w/m.k的导热系数。',
      },
      dielectricCoating: {
        title: '绝缘涂料',
        content: '耐高温绝缘涂层长期最高耐温300摄氏度，短时间可以经受上千度火焰灼烧而依旧保持优异的电绝缘性能。适合新能源汽车，电力，电发热等众多场合。',
      },
      heatConduction: {
        title: '热界面材料',
        content: '导热材料的主要用于芯片等发热部件上面，填充缝隙，让热量能快速的传导出去，降低芯片等发热器件的问题，保温芯片等器件的长期使用可靠性。',
      },
      nanoBoard: {
        title: '纳米隔热板',
        content: '纳米隔热板特殊的设计能对传热路径有效隔断（热传导，热对流，热辐射）而达到有优异的隔热效果。纳米隔热板低温下导热系数比空气还低，在高温段导热系数则具有比气凝胶更低。',
      },
      electricConduction: {
        title: '导电材料',
        content: '以石墨烯为主的导电涂料具有优异的导电和导电发热功能；以银粉为主的导电银浆则具有优异的导电功能。无论是哪一种的导电涂料，都可以在300摄氏度下长期工作。',
      },
      electricHeating: {
        title: '电发热材料',
        content: '用导电涂层来发热。适合不同的基材，包括金属，玻璃，塑料等。发热涂层一般是通过喷涂或者丝印的方式施工到目标基材上面，通过高温来实现成膜固化。',
      },
      heatInsulation: {
        title: '超薄隔热材料',
        content: '气凝胶隔热膜是经过特殊工艺、使纳米气凝胶形成薄膜，提供优异隔热性能，解决消费电子产品狭小有限空间热点、对弱耐热元件的隔热保护，提升产品的寿命和使用性能。',
      },
      dielectric: {
        title: '绝缘材料',
        content: '耐高温绝缘涂层长期最高耐温300摄氏度，短时间可以经受上千度火焰灼烧而依旧保持优异的电绝缘性能。适合新能源汽车，电力，电发热等众多需要在高温环境下依然需要电绝缘的场合。',
      },
    },
    solutions: {
      spaceflight: '航天',
      chemical: '化工',
      electron: '电子',
      transportation: '交通',
      newEnergy: '新能源',
      AI: 'AI',
      architecture: '建筑',
      homeAppliances: '家电',
    },
  },

  // 市场领域
  marketArea: {
    bannerTitle: '市场领域',
    title: '市场领域',
    more: '更多',
    exploreMore: '探索更多应用',
    breadcrumbMarketArea: '市场领域',
    characteristics: {
      heatConduction: '热界面材料',
      heatInsulation: '隔热',
      dielectric: '绝缘材料',
      electricConduction: '导电材料',
      thermalInsulation: '保温',
      fireproof: '防火'
    },
    list: {
      chemical: { 
        title: '化工', 
        content: '石油石化行业是现在世界各国的能源主体，据统计石油石化每年使用的各类保温材料总量比例为总体保温材料的25%，大量的管道及热力设备需保温及保冷绝热，目前保温及保冷绝人状况及技术水平乘次不齐，技术水平高低直接关系到产能建设，成本及环境保护等，Melonbean在保温和防火方面有这比较多的案例，能够提供更为优异的材料，更好的为石油石化行业服务。'
      },
      spaceflight: { 
        title: '航天', 
        content: '近年来航空航天发展迅速，航空航天相关的材料是也得到迅速发展，同时也对材料提出了更多的要求。航天器件的热管理系统中大量使用了隔热材料、导热材料、涂层和导热填料等，均是利用材料自身热物理等特性实现对航天器件温度场的控制。未来，随着人类对外太空的探索越来越频繁，对材料提出更严格要求，如高可靠性材料，轻量化材料，多功能复合材料，极限耐温材料，智能热控材料等，Melonbean在保温防火等方面有这深厚的研究和积累，可以提供特殊的材料供选择。'
      },
      electron: { 
        title: '电子', 
        content: '在电子产品爆发的时代，功能和需求多样化，复杂化情况下，同时开始AI算力等加持下，电子产品设计者/使用者，都追求电子产品更小、更薄、更轻，更快和更可靠，无论是手机、笔记本、穿戴设备，IoT设备，包括现在人形机器人等。现在电子产品的数据处理储存量快速上升，电子产品综合热管理要求更高，导热，散热，均热，隔热等各种手段都运用起来，以满足设备要求。Melonbean在能够定制化不同的产品满足不同的需求，提高电子产品的性能。'
      },
      AI: { 
        title: 'AI', 
        content: '随着AI时代的到来，各种大模型，大运算，大存储等风起云涌，因此芯片的运算变得更多，频率也要求更高，但是产品和设计空间却越来越小，导致AI设备中的各种电子器件的功率密度剧增，热流密度同时也剧增。热管理的挑战也是越来越大，同时推动加速和推动各种热管理产品的发展，比如石墨烯，超薄VC，液冷等。Melonben可以提供不同性能的热管理材料（导热界面材料，保温隔热材料，导电，绝缘等），以满足AI行业的需求。'
      },
      transportation: { 
        title: '交通', 
        content: '传统的交通正在被智能化的交通所替代，如日本的新干线，中国的CRH等，还有越来越多的城市开始建造地铁，人们对于交通运输的要求会逐步提高，新型交通运输材料的研发，旨在提高交通工具的性能、安全性和环保性。这些材料包括轻量化合金、碳纤维复合材料、高强度钢材和纳米技术改性材料。通过使用这些材料，交通工具可以实现减重、降低能耗、减少排放和延长使用寿命的目标。同时，这些材料的应用也促进了交通工具设计的创新，提升了性能和美观度。'
      },
      newEnergy: { 
        title: '新能源', 
        content: '全球气候变暖的前提下，各国都开始大力发展新能源相关的产业（电动汽车，燃料汽车，储能，风能，光伏），这些新型行业对于社会和个人生活都有很大的促进，人们在于CO2的斗争中更加坚定胜利的步伐。这些行业对于新材料的需求也是更加旺盛。电动汽车电池包和储能系统电池包对于热管理的需求更加复杂和苛刻，同时对于防火，保温和绝缘的要求也更高，因此对于这些材料提出了更多的性能，可靠性要求，也要求材料有更多的性能。Melonbean也积极参与新能源领域，做了很多积极有益的尝试，积累了丰富的行业经验。'
      },
      architecture: { 
        title: '建筑', 
        content: '在建筑节能不断推广的过程中，建筑与装饰企业、房地产开发商对建筑保温材料的保温性和防火性都提出了较高要求，力求大幅度减少能源的消耗量，从而减少环境污染和温室效应。在工业中采用良好的保温材料，有助于降低产品能耗，降低生产成本，具有很大的社会效益。建筑行业的发展趋势开始向外墙保温发展，向轻质化发展，向绿色化方向发展，功能多样化方向发展，同时也要求透明保温材料。Melonbean的保温和防火材料可以满足行业的需求，力助全球的环保。'
      },
      homeAppliances: { 
        title: '家电', 
        content: '随着全球生活水平的提高，人们对于生活中家用电器的要求越来越专业和精细化，功能也要求越来越多，比如空气炸锅，烤箱，洗碗机等，同时很多产品也要求接入互联网，比如互联网的电视，冰箱等，因此对各种功能性材料的要求也越来越多，这个也是Melonbean擅长的地方。'
      },
    },
    pages: {
      chemical: {
        title: '化工',
        content: '石油石化行业是现在世界各国的能源主体，据统计石油石化每年使用的各类保温材料总量比例为总体保温材料的25%，大量的管道及热力设备需保温及保冷绝热，目前保温及保冷绝人状况及技术水平乘次不齐，技术水平高低直接关系到产能建设，成本及环境保护等，Melonbean在保温和防火方面有这比较多的案例，能够提供更为优异的材料，更好的为石油石化行业服务。'
      },
      spaceflight: {
        title: '航天',
        content: '近年来航空航天发展迅速，航空航天相关的材料是也得到迅速发展，同时也对材料提出了更多的要求。航天器件的热管理系统中大量使用了隔热材料、导热材料、涂层和导热填料等，均是利用材料自身热物理等特性实现对航天器件温度场的控制。未来，随着人类对外太空的探索越来越频繁，对材料提出更严格要求，如高可靠性材料，轻量化材料，多功能复合材料，极限耐温材料，智能热控材料等，Melonbean在保温防火等方面有这深厚的研究和积累，可以提供特殊的材料供选择。'
      },
      electron: {
        title: '电子',
        content: '在电子产品爆发的时代，功能和需求多样化，复杂化情况下，同时开始AI算力等加持下，电子产品设计者/使用者，都追求电子产品更小、更薄、更轻，更快和更可靠，无论是手机、笔记本、穿戴设备，IoT设备，包括现在人形机器人等。现在电子产品的数据处理储存量快速上升，电子产品综合热管理要求更高，导热，散热，均热，隔热等各种手段都运用起来，以满足设备要求。Melonbean在能够定制化不同的产品满足不同的需求，提高电子产品的性能。'
      },
      AI: {
        title: 'AI',
        content: '随着AI时代的到来，各种大模型，大运算，大存储等风起云涌，因此芯片的运算变得更多，频率也要求更高，但是产品和设计空间却越来越小，导致AI设备中的各种电子器件的功率密度剧增，热流密度同时也剧增。热管理的挑战也是越来越大，同时推动加速和推动各种热管理产品的发展，比如石墨烯，超薄VC，液冷等。Melonben可以提供不同性能的热管理材料（导热界面材料，保温隔热材料，导电，绝缘等），以满足AI行业的需求。'
      },
      transportation: {
        title: '交通',
        content: '传统的交通正在被智能化的交通所替代，如日本的新干线，中国的CRH等，还有越来越多的城市开始建造地铁，人们对于交通运输的要求会逐步提高，新型交通运输材料的研发，旨在提高交通工具的性能、安全性和环保性。这些材料包括轻量化合金、碳纤维复合材料、高强度钢材和纳米技术改性材料。通过使用这些材料，交通工具可以实现减重、降低能耗、减少排放和延长使用寿命的目标。同时，这些材料的应用也促进了交通工具设计的创新，提升了性能和美观度。'
      },
      newEnergy: {
        title: '新能源',
        content: '全球气候变暖的前提下，各国都开始大力发展新能源相关的产业（电动汽车，燃料汽车，储能，风能，光伏），这些新型行业对于社会和个人生活都有很大的促进，人们在于CO2的斗争中更加坚定胜利的步伐。这些行业对于新材料的需求也是更加旺盛。电动汽车电池包和储能系统电池包对于热管理的需求更加复杂和苛刻，同时对于防火，保温和绝缘的要求也更高，因此对于这些材料提出了更多的性能，可靠性要求，也要求材料有更多的性能。Melonbean也积极参与新能源领域，做了很多积极有益的尝试，积累了丰富的行业经验。'
      },
      architecture: {
        title: '建筑',
        content: '在建筑节能不断推广的过程中，建筑与装饰企业、房地产开发商对建筑保温材料的保温性和防火性都提出了较高要求，力求大幅度减少能源的消耗量，从而减少环境污染和温室效应。在工业中采用良好的保温材料，有助于降低产品能耗，降低生产成本，具有很大的社会效益。建筑行业的发展趋势开始向外墙保温发展，向轻质化发展，向绿色化方向发展，功能多样化方向发展，同时也要求透明保温材料。Melonbean的保温和防火材料可以满足行业的需求，力助全球的环保。'
      },
      homeAppliances: {
        title: '家电',
        content: '随着全球生活水平的提高，人们对于生活中家用电器的要求越来越专业和精细化，功能也要求越来越多，比如空气炸锅，烤箱，洗碗机等，同时很多产品也要求接入互联网，比如互联网的电视，冰箱等，因此对各种功能性材料的要求也越来越多，这个也是Melonbean擅长的地方。'
      }
    }
  },

  // 产品中心
  productCenter: {
    bannerTitle: '产品中心',
    title: '产品中心',
    more: '更多',
    breadcrumbProductCenter: '产品中心',
    breadcrumbProductInfo: '产品详情',
    productDetail: '产品详情',
    downloadManual: '产品手册下载',
    contactForMore: '需要更多产品信息，请联系公司业务和当地渠道',
    
    // 产品列表
    products: {
      heatConduction: {
        name: '热界面材料',
        content: '导热材料的主要用于芯片等发热部件上面，填充缝隙，让热量能快速的传导出去，降低芯片等发热器件的问题，保温芯片等器件的长期使用可靠性。导热材料是一个系列的材料，主要有导热垫片，导热凝胶，导热相变片，导热脂，导热胶带，石墨片等，广泛用于电子行业，通讯，汽车，工业领域等各个行业。'
      },
      nanoBoard: {
        name: '纳米板',
        content: '纳米隔热板特殊的设计能对传热路径有效隔断（ 热传导，热对流，热辐射）而达到有优异的隔热效果。产品是以纳米材料为基础，辅助以高温增强和高温隔热成分，采用特殊成型工艺加工而成。 纳米隔热板低温下导热系数比空气还低，在高温段导热系数则具有比气凝胶更低，同时具有极高热稳定性和超强冷热冲击性能。纳米隔热板的隔热性能是传统材料的隔热性能的数倍，是市场上最理想的高温隔热材料'
      },
      thermalInsulation: {
        name: '保温隔热材料',
        content: '保温隔热涂料主要通过喷涂的方式施工到需要保温隔热的基材上，包括金属，无机，塑料等，尤其适合异型位置。保温隔热涂料具有最低为0.025w/m.k的导热系数，主要保温隔热填料为二氧化硅气凝胶。针对不同的工作温度，采用了不同杂化比例的有机无机杂化体系，可以满足零下40度到零上最高为1000摄氏度的区间。'
      },
      fireproof: {
        name: '防火/耐高温涂层',
        content: '以有机无机杂化硅合树脂为主体的耐高温涂层，具有优异的耐高温性能。加上合适的填料，可以做到最高短时间耐温超过2000摄氏度，长时间工作温度650摄氏度。不加颜填料的清漆也可以在不锈钢板上最高耐温1000摄氏度。有的涂层具有高温减缓不锈钢氧化的功能；有的涂层具有优异的防腐性能。此外，这类产品大多具有高硬度的特性，提供优异的耐磨和防刮擦性能。'
      },
      heatInsulation: {
        name: '超薄隔热材料',
        content: '气凝胶隔热膜是经过特殊工艺、使纳米气凝胶形成薄膜，提供优异隔热性能，解决消费电子产品狭小有限空间热点、对弱耐热元件的隔热保护，提升产品的寿命和使用性能。纳米气凝胶隔热膜通过气凝胶纳米空隙来阻隔热量传递的方向，从而降低产品的表面温度，减少或消除产品表面的热点，提升消费者对电子产品的体感度。可以与其他功能材料复合使用（如与石墨的复合），可以大大提高材料的隔热性能'
      },
      electricHeating: {
        name: '电发热材料',
        content: '用导电涂层来发热。适合不同的基材，包括金属，玻璃，塑料等。发热涂层一般是通过喷涂或者丝印的方式施工到目标基材上面，通过高温来实现成膜固化。导电发热涂层可以做在不同形状的基材，发热面积和形状也可以根据要求灵活实现。'
      },
      dielectric: {
        name: '绝缘材料',
        content: '耐高温绝缘涂层长期最高耐温300摄氏度，短时间可以经受上千度火焰灼烧而依旧保持优异的电绝缘性能。适合新能源汽车，电力，电发热等众多需要在高温环境下依然需要电绝缘的场合。'
      },
      electricConduction: {
        name: '导电材料',
        content: '以石墨烯为主的导电涂料具有优异的导电和导电发热功能；以银粉为主的导电银浆则具有优异的导电功能。无论是哪一种的导电涂料，都可以在300摄氏度下长期工作；此外，涂料的固化温度不超过300摄氏度。'
      }
    },

    // 产品详情页签
    tabs: {
      hpcm: '导热相变化材料-HPCM',
      hgp: '导热垫⽚-HGP',
      hgpPt: '导热凝胶垫⽚-HGP PT',
      hg: '单组份导热凝胶-HG',
      hf: '双组分导热凝胶-HF',
      hgr: '导热硅脂-HGR',
      hi: '导热绝缘片-HI',
      htb: '导热吸波垫片-HTB',
      hlm: '液态金属片-HLM',
      ahi: '气凝胶隔热膜-AHI',
      ahiFoam: '气凝胶泡棉-AHI',
      nanoBoard: '纳米板'
    },

    // 产品组件公共标签
    common: {
      productFeatures: '产品特点',
      typicalApplications: '典型应用',
      technicalParameters: '技术参数',
      testMethod: '测试方法',
      project: '项目',
      color: '颜色',
      phaseChangeTemp: '相变温度',
      density: '密度',
      workingTemp: '工作温度',
      volumeResistivity: '体积电阻',
      thermalConductivity: '导热系数',
      thermalResistance: '热阻抗',
      pressure: '压强',
      thickness: '厚度',
      hardness: '硬度',
      tempRange: '耐温范围',
      dielectricConstant: '介电常数',
      fireRating: '防火等级',
      component: '成分',
      annotation: '*无氧化锌版本',
      thermalResistanceVsPressure: '热阻抗vs.压强',
      visualInspection: '目视',
      gray: '灰色'
    },

    // 产品1 - 导热相变化材料HPCM
    product1: {
      description: '导热相变化材料是一种特的配方及工艺制成的具有高导热性能，能够在一定温度下相变，提高界面浸润性能的界面材料。材料在相变温度以下是固体，方便使用和返工，当达到相变温度后材料变软，具有非常优异的润湿效果，可以极高降低界面热阻，提升材料的传热能力。',
      features: [
        '2.5~10.0W/m-k的导热系数',
        '超低的热阻',
        '较低的相变温度',
        '方便模切加工',
        '优良的可靠性'
      ],
      applications: [
        'CPU&GPU&APU',
        'IGBT模组',
        '通讯设备',
        '电脑/计算机',
        '服务器/数据中心'
      ]
    },

    // 产品3 - 导热凝胶垫片HGP PT
    product3: {
      description: '导热凝胶垫片是一种低界面热阻的弹性聚合物材料，具有优异的导热性能和自粘性，能有效填充不规则间隙，为散热提供高效的热传导路径。',
      features: [
        '低界面热阻',
        '优异表面自粘性，方便安装', 
        '超低硬度，减少安装应力残余',
        '高压缩比，利于间隙的填充'
      ],
      applications: [
        '液冷模块/服务器',
        '通讯基站设备',
        'AI设备',
        'CPU/GPU/APU',
        '汽车电子'
      ],
      tableData: [
        {
          project: '成分',
          test: '-',
          parameter1: '有机硅',
          parameter2: '有机硅',
          parameter3: '有机硅'
        },
        {
          project: '颜色',
          test: '目视',
          parameter1: '白色',
          parameter2: '灰色',
          parameter3: '灰色'
        },
        {
          project: '导热系数｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '3.5',
          parameter2: '6.0',
          parameter3: '8.0'
        },
        {
          project: '厚度｜(mm)',
          test: '-',
          parameter1: '0.5~5.0',
          parameter2: '1.0~5.0',
          parameter3: '1.0~5.0'
        },
        {
          project: '密度｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '3.2',
          parameter2: '3.3',
          parameter3: '3.4'
        },
        {
          project: '硬度｜(shore 00)',
          test: 'ASTM D2240',
          parameter1: '10',
          parameter2: '10',
          parameter3: '10'
        },
        {
          project: '耐温范围｜(℃)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150'
        },
        {
          project: '介电常数｜@1MHZ',
          test: 'ASTM D150',
          parameter1: '7.0',
          parameter2: '8.0',
          parameter3: '10.0'
        },
        {
          project: '体积电阻率｜(Ω-cm)',
          test: 'ASTM D257',
          parameter1: '10¹³',
          parameter2: '10¹³',
          parameter3: '10¹³'
        },
        {
          project: '防火等级',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0'
        }
      ]
    },

    // 产品4 - 单组份导热凝胶HG
    product4: {
      description: '单组份导热凝胶是一系列的高性能导热界面材料具有低界面热阻、高可塑性、高电气绝缘、高可靠性等优点。同时具有高温不分油、不干固、不腐蚀材料、耐高低温、触变性好等特性,应用于各种元器件应力极低需求,使各种应用产品具有高可靠性。\n\n本身具有自然粘性,方便客户组装。同时,客户可以根据自身工艺实现自动化点胶,提高生产效率。',
      features: [
        '2.0~9.0W/m-K导热系数',
        '超低应力：>40%@10psi',
        '优秀的浸润性，有效减低界面热阻',
        '高压缩比，适用不同间隙的芯片传热'
      ],
      applications: [
        '汽车电子',
        '大型存储设备',
        '消费电子设备',
        '通讯基站设备(4G和5G)',
        '电源模组'
      ],
      tableData: [
        {
          project: '成分',
          test: '-',
          parameter1: '有机硅',
          parameter2: '有机硅',
          parameter3: '有机硅',
          parameter4: '有机硅',
          parameter5: '有机硅'
        },
        {
          project: '颜色',
          test: '目视',
          parameter1: '蓝色',
          parameter2: '绿色',
          parameter3: '蓝色',
          parameter4: '灰色',
          parameter5: '粉色'
        },
        {
          project: '导热系数｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.0',
          parameter2: '3.5',
          parameter3: '5.0',
          parameter4: '7.0',
          parameter5: '9.0'
        },
        {
          project: '密度｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.0',
          parameter2: '3.2',
          parameter3: '3.2',
          parameter4: '3.4',
          parameter5: '3.5'
        },
        {
          project: '挤出速率｜(g/min)',
          test: '30cc标准管,90psi气压',
          parameter1: '40',
          parameter2: '35',
          parameter3: '35',
          parameter4: '15',
          parameter5: '10'
        },
        {
          project: '挥发度｜(%)',
          test: 'ASTM E595',
          parameter1: '<0.05',
          parameter2: '<0.05',
          parameter3: '<0.05',
          parameter4: '<0.03',
          parameter5: '<0.03'
        },
        {
          project: '耐温范围｜(℃)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150',
          parameter4: '-40~150',
          parameter5: '-40~150'
        },
        {
          project: '介电常数｜@1MHZ',
          test: 'ASTM D150',
          parameter1: '5.0',
          parameter2: '8.0',
          parameter3: '7.5',
          parameter4: '8.0',
          parameter5: '8.0'
        },
        {
          project: '防火等级',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0',
          parameter5: 'V-0'
        }
      ]
    },

    // 产品5 - 双组分导热凝胶HF
    product5: {
      description: '双组份导热凝胶材料通过A剂（主剂）和B剂（固化剂）按一定比例混合后，在常温下固化成柔韧的弹性体，具备优秀的导热性能和电气绝缘性能。固化后的材料保持良好的柔韧性和回弹性，能够很好地贴合各种不规则表面，提供稳定的热传导路径。该系列产品可根据不同应用需求提供多种导热系数规格。',
      features: [
        '2.0~8.0W/m-K导热系数',
        '优异的电气绝缘性能',
        '固化后保持柔韧性和弹性',
        '优秀的贴合性，适应不规则表面',
        '良好的长期稳定性'
      ],
      applications: [
        '汽车电子ECU',
        '充电桩模块',
        '通讯基站设备',
        '储能电池包',
        'LED照明散热'
      ],
      tableData: [
        {
          project: '成分',
          test: '-',
          parameter1: '有机硅',
          parameter2: '有机硅',
          parameter3: '有机硅',
          parameter4: '有机硅',
          parameter5: '有机硅',
          parameter6: '有机硅'
        },
        {
          project: '颜色',
          test: '目视',
          parameter1: '蓝色',
          parameter2: '蓝色',
          parameter3: '绿色',
          parameter4: '蓝色',
          parameter5: '灰色',
          parameter6: '灰色'
        },
        {
          project: '导热系数｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.0',
          parameter2: '2.0',
          parameter3: '3.5',
          parameter4: '5.0',
          parameter5: '6.0',
          parameter6: '8.0'
        },
        {
          project: '密度｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.2',
          parameter2: '2.0',
          parameter3: '3.2',
          parameter4: '3.2',
          parameter5: '3.3',
          parameter6: '3.4'
        },
        {
          project: '硬度｜(邵氏A)',
          test: 'ASTM D2240',
          parameter1: '15',
          parameter2: '10',
          parameter3: '25',
          parameter4: '35',
          parameter5: '40',
          parameter6: '45'
        },
        {
          project: '拉伸强度｜(MPa)',
          test: 'ASTM D412',
          parameter1: '0.8',
          parameter2: '0.6',
          parameter3: '1.2',
          parameter4: '1.5',
          parameter5: '1.8',
          parameter6: '2.0'
        },
        {
          project: '操作时间｜(min)',
          test: '25℃',
          parameter1: '45',
          parameter2: '90',
          parameter3: '45',
          parameter4: '40',
          parameter5: '35',
          parameter6: '30'
        },
        {
          project: '固化时间｜(h)',
          test: '25℃',
          parameter1: '24',
          parameter2: '24',
          parameter3: '24',
          parameter4: '24',
          parameter5: '24',
          parameter6: '24'
        },
        {
          project: '耐温范围｜(℃)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150',
          parameter4: '-40~150',
          parameter5: '-40~150',
          parameter6: '-40~150'
        },
        {
          project: '介电常数｜@1MHZ',
          test: 'ASTM D150',
          parameter1: '5.0',
          parameter2: '4.5',
          parameter3: '8.0',
          parameter4: '7.5',
          parameter5: '8.0',
          parameter6: '8.5'
        },
        {
          project: '防火等级',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0',
          parameter5: 'V-0',
          parameter6: 'V-0'
        }
      ]
    },

    // 产品6 - 导热硅脂HGR
    product6: {
      description: '导热硅脂是一种高性能的导热界面材料，具有优异的导热性能和电气绝缘性能。产品采用有机硅树脂为基材，添加多种高导热无机粉体，经特殊工艺制备而成。具有良好的触变性和可操作性，能够有效填充发热元件与散热器之间的微小间隙，显著降低接触热阻，提高散热效率。',
      features: [
        '2.0~6.0W/m-K导热系数',
        '优异的触变性，易于施工',
        '优秀的电气绝缘性能',
        '良好的化学稳定性',
        '低界面厚度，高效传热'
      ],
      applications: [
        'CPU/GPU散热',
        '电源模块',
        'LED灯具',
        '汽车电子',
        '通讯设备'
      ],
      tableData: [
        {
          project: '成分',
          test: '-',
          parameter1: '有机硅',
          parameter2: '有机硅',
          parameter3: '有机硅',
          parameter4: '有机硅'
        },
        {
          project: '颜色',
          test: '目视',
          parameter1: '黄色',
          parameter2: '灰色',
          parameter3: '灰色',
          parameter4: '灰色'
        },
        {
          project: '最小界面厚度',
          test: '-',
          parameter1: '0.030',
          parameter2: '0.045',
          parameter3: '0.045',
          parameter4: '0.04'
        },
        {
          project: '密度｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '3.1',
          parameter2: '2.9',
          parameter3: '2.9',
          parameter4: '2.9'
        },
        {
          project: '粘度',
          test: 'ASTM D2196',
          parameter1: '<100,000',
          parameter2: '<400,000',
          parameter3: '<250,000',
          parameter4: '<250,000'
        },
        {
          project: '耐温范围｜(°C)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150',
          parameter4: '-40~150'
        },
        {
          project: '体积电阻率|(Ω.cm)',
          test: 'ASTM D257',
          parameter1: '10¹²',
          parameter2: '10¹¹',
          parameter3: '10¹¹',
          parameter4: '10¹¹'
        },
        {
          project: '防火等级',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0'
        },
        {
          project: '导热系数｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.0',
          parameter2: '3.5',
          parameter3: '5.0',
          parameter4: '6.0'
        }
      ],
      tableDataTwo: [
        {
          project: '压强｜(psi)',
          test: '-',
          parameter1: '50/100',
          parameter2: '50/100',
          parameter3: '50/100',
          parameter4: '50/100'
        },
        {
          project: '热阻抗｜(℃-cm²/W)',
          test: 'ASTM D5470',
          parameter1: '0.13/0.11',
          parameter2: '0.06/0.05',
          parameter3: '0.05/0.04',
          parameter4: '0.045/0.038'
        }
      ]
    },

    // 产品7 - 导热绝缘片HI
    product7: {
      description: '导热绝缘片是一系列以玻纤布等为补强材料的高性能热界面材料，具有优良的抗切割能力和极好的导热性能，被广泛应用于电子电器等行业。使用时，根据发热界面的大小间隙高度选择不同厚度的导热硅胶片裁切，安放在发热界面与其组件的空隙处，起导热介质作用。',
      features: [
        '最高到3.5W/m-K导热系数',
        '击穿电压>6,000Vac',
        '柔韧片材，便于成型，可以按照客户需求进行裁切',
        '防潮，耐候性出色，可靠性高，容易拆卸',
        '制备单面粘性产品(A1)'
      ],
      applications: [
        'OBC车载充电器',
        '功率放大器',
        '电源',
        '汽车电子',
        '功率半导体'
      ],
      pressureLabel: '压强(psi)',
      thermalResistanceLabel: '热阻抗(℃-cm²/W)',
      tableData: [
        {
          project: '成分',
          test: '-',
          parameter1: '硅胶+玻纤',
          parameter2: '硅胶+玻纤',
          parameter3: '硅胶+玻纤',
          parameter4: '硅胶+PI'
        },
        {
          project: '颜色',
          test: '目视',
          parameter1: '棕红色',
          parameter2: '黑色',
          parameter3: '白色',
          parameter4: '黄色'
        },
        {
          project: '厚度｜(mm)',
          test: 'ASTM D374',
          parameter1: '0.23',
          parameter2: '0.23',
          parameter3: '0.25/0.38/0.5',
          parameter4: '0.15'
        },
        {
          project: '密度｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.5',
          parameter2: '2.7',
          parameter3: '1.5',
          parameter4: '2.5'
        },
        {
          project: '硬度｜(shore A)',
          test: 'ASTM D2240',
          parameter1: '92',
          parameter2: '80',
          parameter3: '70',
          parameter4: '90'
        },
        {
          project: '拉伸强度｜(MPa)',
          test: 'ASTM D412',
          parameter1: '9.0',
          parameter2: '9.0',
          parameter3: '15',
          parameter4: '20'
        },
        {
          project: '耐温范围｜(°C)',
          test: '-',
          parameter1: '-60~200',
          parameter2: '-60~200',
          parameter3: '-60~200',
          parameter4: '-60~180'
        },
        {
          project: '击穿电压｜(Kv)',
          test: 'ASTM D149',
          parameter1: '>5.5',
          parameter2: '>6.0',
          parameter3: '>4.0',
          parameter4: '>6.0'
        },
        {
          project: '防火等级',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0'
        },
        {
          project: '导热系数｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '1.6',
          parameter2: '1.8',
          parameter3: '3.5',
          parameter4: '1.3'
        }
      ],
      tableDataTwo: [
        {
          project: '压强｜(psi)',
          test: '-',
          parameter1: '50',
          parameter2: '0.61',
          parameter3: '0.53',
          parameter4: '0.27',
          parameter5: '0.41'
        },
        {
          project: '热阻抗｜(℃-cm²/W)',
          test: 'ASTM D5470',
          parameter1: '100',
          parameter2: '0.47',
          parameter3: '0.47',
          parameter4: '0.25',
          parameter5: '0.38'
        }
      ]
    },

    // 产品8 - 导热吸波垫片HTB
    product8: {
      description: '导热吸波材料垫片是一系列具有高热性能,同时具有一定的EMI性能的热界面材料,现广泛应用于光模块,通讯基站等上面。使用时,根据发热界面的大小间隙高度选择不同厚度的导热硅胶片裁切,安放在发热界面与其组件的空隙处,起到很好传热功能,同时可以消除一定电磁干扰,保证元器件的稳定工作。',
      features: [
        '类似传统导热垫片，表面带有自粘性方便应用',
        '极低的热阻并且兼具EMI屏蔽效果',
        '高可靠性',
        '可部分替代金属屏蔽罩，降低成本，容易操作'
      ],
      applications: [
        '机箱或者相关散热模块',
        '智能终端',
        '通信设备',
        '消费电子'
      ],
      tableData: [
        {
          project: '颜色',
          test: '目视',
          parameter1: '黑色',
          parameter2: '黑色',
          parameter3: '黑色'
        },
        {
          project: '厚度｜(mm)',
          test: 'ASTM D374',
          parameter1: '0.5-5.0',
          parameter2: '0.5-5.0',
          parameter3: '0.5-5.0'
        },
        {
          project: '导热系数｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '1.4',
          parameter2: '3',
          parameter3: '6.0'
        },
        {
          project: '密度｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '4.0',
          parameter2: '3.5',
          parameter3: '4.5'
        },
        {
          project: '硬度｜(shore 00)',
          test: 'ASTM D2240',
          parameter1: '92',
          parameter2: '80',
          parameter3: '70'
        },
        {
          project: '体积电阻率｜(Ω.cm)',
          test: 'ASTM D257',
          parameter1: '10¹²',
          parameter2: '10¹²',
          parameter3: '‌10⁸‌'
        },
        {
          project: 'EMI衰减',
          test: '(dB/cm)@2 GHz｜(dB/cm) @ 5 GHz',
          parameter1: '8｜15',
          parameter2: '10｜20',
          parameter3: '10｜20'
        },
        {
          project: '操作温度｜(°C)',
          test: '/',
          parameter1: '-40~180',
          parameter2: '-40~180',
          parameter3: '-40~180'
        },
        {
          project: '防火等级',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0'
        }
      ]
    },

    // 产品9 - 液态金属片HLM
    product9: {
      description: '液态金属片是一列超高性能的界面材料,使用在发热器件和散热器中间,达到液态金属的相变温度后材料会自动软化填充发热器件和散热器之间的空隙其具有非常低的界面热阻,能够快速的将发热器件的产生的热量传递到冷面,高效的降低发热器件温度,保证电子元器件的性能。',
      features: [
        '超高导热率(20~50W/m-k)',
        '产品高可靠性',
        '无泵出',
        '无有机物挥发',
        '环境友好'
      ],
      applications: [
        '服务器',
        '游戏机',
        'GPU/CPU/APU',
        '通讯设备',
        '汽车电子'
      ],
      tableData: [
        {
          project: '基材',
          test: '-',
          parameter1: '铋合金',
          parameter2: '铋合金',
          parameter3: '铋合金'
        },
        {
          project: '颜色',
          test: '目视',
          parameter1: '亮银色',
          parameter2: '亮银色',
          parameter3: '亮银色'
        },
        {
          project: '厚度｜(mm)',
          test: 'ASTM D374',
          parameter1: '0.07~0.30',
          parameter2: '0.07~0.30',
          parameter3: '0.07~0.30'
        },
        {
          project: '相变点｜(°C)',
          test: 'ASTM B774',
          parameter1: '72',
          parameter2: '118',
          parameter3: '60/119'
        },
        {
          project: '硬度｜(HB)',
          test: 'ASTME10',
          parameter1: '4.5',
          parameter2: '4.5',
          parameter3: '7.5'
        },
        {
          project: '密度｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '8.0',
          parameter2: '7.2',
          parameter3: '7.5'
        },
        {
          project: '操作温度｜(°C)',
          test: '-',
          parameter1: '-50~500',
          parameter2: '-50~500',
          parameter3: '-50~500'
        },
        {
          project: '体积电阻｜(Ω.m)',
          test: 'ASTM D257',
          parameter1: '10⁻⁸',
          parameter2: '10⁻⁸',
          parameter3: '10⁻⁸'
        },
        {
          project: '导热系数｜(W/m-K)',
          test: 'ASTM E1461',
          parameter1: '30',
          parameter2: '43',
          parameter3: '30'
        }
      ]
    },

    // 产品10 - 气凝胶隔热膜AHI
    product10: {
      description: '气凝胶隔热膜是一系列纳米气凝胶隔热构成的隔热膜,经过特殊工艺、使纳米气凝胶形成薄膜,提供优异的隔热性能,解决消费电子产品狭小有限空间热点、对弱耐热元件的隔热保护,控制改变热量传导的方向,提升产品的寿命和使用性能,纳米气凝胶隔热膜通过气凝胶纳米空隙来阻隔热量传递的方向,从而降低产品的表面温度,减少或消除产品表面的热点,提升消费者对电子产品的体感度。\n\n气凝胶隔热膜可以做成单面粘性的材料,方便客户安装,可以与其他功能材料复合使用(如与石墨的复合),可以大大提高材料的隔热性能。',
      features: [
        '0.018~0.023W/m-k的低导热系数',
        '厚度范围0.05-0.4mm',
        '优秀电绝缘方便模切',
        '可以和其他材料一起贴合使用'
      ],
      applications: [
        '电子烟',
        '智能手机',
        '平板/笔记本',
        '智能手表'
      ],
      tableData: [
        {
          project: '材料',
          test: '-',
          parameter1: '气凝胶',
          parameter2: '气凝胶',
          parameter3: '气凝胶',
          parameter4: '气凝胶',
          parameter5: '气凝胶'
        },
        {
          project: '颜色',
          test: '目视',
          parameter1: '白色',
          parameter2: '白色',
          parameter3: '白色',
          parameter4: '银亮色',
          parameter5: '银亮色'
        },
        {
          project: '导热系数｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '0.018～0.023',
          parameter2: '0.018～0.023',
          parameter3: '0.018～0.023',
          parameter4: '0.018～0.023',
          parameter5: '0.018～0.023'
        },
        {
          project: '厚度｜(mm)',
          test: '-',
          parameter1: '0.05',
          parameter2: '0.10',
          parameter3: '0.20',
          parameter4: '0.30',
          parameter5: '0.40'
        },
        {
          project: '密度｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '0.3',
          parameter2: '0.3',
          parameter3: '0.3',
          parameter4: '0.3',
          parameter5: '0.3'
        },
        {
          project: '工作温度｜(℃）',
          test: '-',
          parameter1: '-40～130',
          parameter2: '-40～130',
          parameter3: '-40～130',
          parameter4: '-40～130',
          parameter5: '-40～130'
        },
        {
          project: '绝缘强度｜(Kv/mm)',
          test: 'ASTM D149',
          parameter1: '>4.0',
          parameter2: '>4.0',
          parameter3: '>4.0',
          parameter4: '>4.0',
          parameter5: '>4.0'
        },
        {
          project: '体积电阻｜(Ω-cm)',
          test: 'ASTM D257',
          parameter1: '10¹³',
          parameter2: '10¹³',
          parameter3: '10¹³',
          parameter4: '10¹³',
          parameter5: '10¹³'
        }
      ]
    },

    // 产品11 - 气凝胶泡棉AHI
    product11: {
      description: '气凝隔热胶泡棉是一系列纳米气凝胶构成的隔热泡棉是经过特殊超临界工艺形成网状多孔的纳米气凝胶结构,从而提供优异的隔热能力,提供弱耐热元件的隔热保护,同时材料据有较高的压缩性,能够更好的填充一些异形空间,达到更好的隔热效果,提升产品的寿命和是使用体验。\n\n气凝胶隔热泡棉可以做成单面粘性的材料,方便客户安装,也可以与其他功能材料复合使用(如石墨复合),提供复利性能。',
      features: [
        '0.018w/m-k的超低导热系数',
        '厚度0.5-3.0mm',
        '优异的压缩性能',
        '优秀电绝缘',
        '方便模切'
      ],
      applications: [
        '电子烟',
        '智能手机',
        '平板/笔记本',
        '智能手表'
      ],
      tableData: [
        {
          project: '材料',
          test: '-',
          parameter1: '气凝胶',
          parameter2: '气凝胶',
          parameter3: '气凝胶',
          parameter4: '气凝胶'
        },
        {
          project: '颜色',
          test: '目视',
          parameter1: '白色',
          parameter2: '白色',
          parameter3: '白色',
          parameter4: '银亮色'
        },
        {
          project: '导热系数｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '0.018',
          parameter2: '0.07~0.30',
          parameter3: '0.018',
          parameter4: '0.018'
        },
        {
          project: '厚度｜(mm)',
          test: '-',
          parameter1: '0.5',
          parameter2: '1.0',
          parameter3: '2.0',
          parameter4: '3.0'
        },
        {
          project: '密度｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '-0.1',
          parameter2: '-0.1',
          parameter3: '-0.1',
          parameter4: '-0.1'
        },
        {
          project: '工作温度｜(°C)',
          test: '-',
          parameter1: '-60~240',
          parameter2: '-60~240',
          parameter3: '-60~240',
          parameter4: '-60~240'
        },
        {
          project: '绝缘强度｜(Kv/mm)',
          test: 'ASTM D149',
          parameter1: '>3.0',
          parameter2: '>3.0',
          parameter3: '>3.0',
          parameter4: '>3.0'
        },
        {
          project: '体积电阻｜(Ω-cm)',
          test: 'ASTM D257',
          parameter1: '10¹³',
          parameter2: '10¹³',
          parameter3: '10¹³',
          parameter4: '10¹³'
        }
      ]
    },

    // 产品12 - 纳米板
    product12: {
      description: '纳米板是高隔热性能材料，基于对材料的深入研究,开发出的对传热路径的有效隔断（ 热传导，热对流，热辐射）从而达到有效和优异的隔热效果。产品是以气凝胶等纳米材料为基础材料，辅助以高温增强和高温隔热成分，采用特殊的成型工艺加工而成。\n纳米板材料在低温下比空气还要低的导热系数，在高温段则具有比气凝胶更低的导热系数，同时具有极高的热稳定性和超强的冷热冲击性能。 气凝胶太空板的隔热性能是传统材料的隔热性能的数倍，是市场上最理想的高温隔热材料。',
      productFeaturesTitle: '产品特点',
      productFeaturesIntro: '材料的导热率 λ是由材料对热的三个特性的表征而成的：<br>λtotal = λ传导 + λ对流+ λ辐射',
      productFeatures: [
        '在气凝胶等纳米材料中，纳米级的结构能够有极小的接触点，同时纳米结构也极大的延长了传热路径，从而降低了材料的λ传导。',
        '在气凝胶等纳米材料中，纳米级的结构能够形成有效的孔隙率（高达90%），同时细小的纳米结构也有效的消除空气的对流（气体分子的平均自程 为70-120nm），从而降低了传热λ对流。',
        '在材料结构中增加热隔热组分，因此能够降低材料的热辐射能力，减小了λ辐射。'
      ],
      productFeaturesTip: '从而整体降低了材料的导热率λtotal',
      productDetailTitle: '产品详情',
      productDetailItems: [
        '纳米板在高温段同样保持极低的导热系数,对高温隔热有明显效果,第三方测试报告可以看到800°C下导热系数也仅有0.036W/m-k,其明显优于超临界气凝胶。',
        '同市场上超临界干燥的气凝胶毡做了对比，纳米板隔热性能有明显的优势(热板法)。',
        '',
        '纳米板具有有一定的压缩性能,保证使用在电芯间能够吸收一定的电芯膨胀,保证电芯的机械性能,同时可以根据客户要求做定制开发。'
      ],
      agingTips: '老化测试，85°C&85%RH老化1000小时，125°C高温老化 1000小时，纳米板的导热系数，隔热性能，耐压测试基本没有变化，压缩性能略有变化，具体如下:',
      bottomTips: '*以上材料都是带PET热固膜做的测试',
      tableHeaders: {
        unit: '单位',
        testStandard: '测试标准',
        agingCondition: '老化条件',
        testTemperature: '测试温度℃',
        thermalConductivity: '导热系数W/(m-K)',
        insulationTest: '隔热测试-温差',
        coldSideTemp: '隔热测试-冷面温度',
        voltageTest: '耐压测试（3000V/60S)',
        compressionTest: '压缩测试',
        strain: '应变(%)',
        pressure: '压强'
      },
      tableData: [
        {
          project: '使用温度｜Operation Temperature',
          test: '°C',
          parameter1: '700',
          parameter2: '950',
          parameter3: '1100',
          parameter4: '1200',
          parameter5: '-'
        },
        {
          project: '颜色｜Color',
          test: '-',
          parameter1: '灰色/白色',
          parameter2: '灰色/白色',
          parameter3: '灰色/白色',
          parameter4: '灰色/白色',
          parameter5: 'Visual'
        },
        {
          project: '厚度｜Thickness',
          test: 'mm',
          parameter1: '1.0~5mm',
          parameter2: '1.0~5mm',
          parameter3: '1.0~5mm',
          parameter4: '1.0~5mm',
          parameter5: '-'
        },
        {
          project: '密度｜Density',
          test: 'kg/m3',
          parameter1: '300',
          parameter2: '300',
          parameter3: '300',
          parameter4: '300',
          parameter5: 'GB/T 17911'
        },
        {
          project: '抗拉强度｜Tensile Strength',
          test: 'MPa',
          parameter1: '0.15',
          parameter2: '0.15',
          parameter3: '0.15',
          parameter4: '0.15',
          parameter5: 'GB/T 17911'
        },
        {
          project: '压缩性能｜Compression Stress',
          test: '-',
          parameter1: '15%(1MPa)｜25%(2MPa)',
          parameter2: '15%(1MPa)｜25%(2MPa)',
          parameter3: '15%(1MPa)｜25%(2MPa)',
          parameter4: '15%(1MPa)｜25%(2MPa)',
          parameter5: 'Internal'
        },
        {
          project: '绝缘强度｜Electrical Strength',
          test: 'kv/mm',
          parameter1: '2.0',
          parameter2: '2.1',
          parameter3: '2.1',
          parameter4: '2.0',
          parameter5: 'GB/T 1408'
        },
        {
          project: '表面电阻｜Surface Resistance',
          test: 'Ohms',
          parameter1: '>1×10⁹',
          parameter2: '>1×10⁹',
          parameter3: '>1×10⁹',
          parameter4: '>1×10⁹',
          parameter5: 'GB/T 1410'
        },
        {
          project: '耐压测试｜Hi-pot test',
          test: '3000V｜DC/60S',
          parameter1: 'Pass',
          parameter2: 'Pass',
          parameter3: 'Pass',
          parameter4: 'Pass',
          parameter5: 'IEC 60950'
        },
        {
          project: '热容｜Heat Capacity',
          test: 'J/g·℃',
          parameter1: '1.09',
          parameter2: '1.1',
          parameter3: '1.13',
          parameter4: '1.15',
          parameter5: 'ISO 11357-4'
        },
        {
          project: '导热系数｜Thermal Conductivity',
          test: 'W/m-k｜25℃｜200℃｜400℃｜600℃｜800℃',
          parameter1: '-｜0.021｜0.024｜0.026｜0.030｜0.038',
          parameter2: '-｜0.020｜0.022｜0.026｜0.030｜0.036',
          parameter3: '-｜0.019｜0.021｜0.023｜0.026｜0.036',
          parameter4: '-｜0.021｜0.023｜0.026｜0.029｜0.037',
          parameter5: 'GB/T10294'
        },
        {
          project: '阻燃性|Flammability',
          test: '-',
          parameter1: 'v-0',
          parameter2: 'v-0',
          parameter3: 'v-0',
          parameter4: 'v-0',
          parameter5: 'UL94'
        },
        {
          project: '符合性|EHS Compliance',
          test: '-',
          parameter1: '符合',
          parameter2: '符合',
          parameter3: '符合',
          parameter4: '符合',
          parameter5: '/'
        }
      ],
      tableDataChart: [
        {
          project: '压强(Mpa)',
          test: '0.50',
          parameter1: '1.00',
          parameter2: '1.50',
          parameter3: '2.00',
          parameter4: '2.50'
        }
      ],
      tableData2: [
        {
          project: '老化前',
          test: '25',
          parameter1: '0.0253'
        },
        {
          project: '125℃ 500hrs',
          test: '25',
          parameter1: '0.0272'
        },
        {
          project: '125℃ 1000hrs',
          test: '25',
          parameter1: '0.0243'
        },
        {
          project: '85℃&85%RH 500hrs',
          test: '25',
          parameter1: '0.0253'
        },
        {
          project: '85℃&85%RH 1000hrs',
          test: '25',
          parameter1: '0.0260'
        }
      ],
      tableData3: [
        {
          project: '老化前',
          test: '85℃&85%RH（500hrs）',
          parameter1: '85℃&85%RH（1000hrs）',
          parameter2: '125℃（500hrs）',
          parameter3: '125℃（1000hrs）'
        },
        {
          project: '504.775',
          test: '500',
          parameter1: '503.9',
          parameter2: '505.3',
          parameter3: '503.6'
        }
      ],
      tableData4: [
        {
          project: '老化前',
          test: '85℃&85%RH（500hrs）',
          parameter1: '85℃&85%RH（1000hrs）',
          parameter2: '125℃（500hrs）',
          parameter3: '125℃（1000hrs）'
        },
        {
          project: '160.5',
          test: '165.3',
          parameter1: '158.3',
          parameter2: '164.7',
          parameter3: '164.5'
        }
      ],
      tableData5: [
        {
          project: '老化前',
          test: '85℃&85%RH（500hrs）',
          parameter1: '85℃&85%RH（1000hrs）',
          parameter2: '125℃（500hrs）',
          parameter3: '125℃（1000hrs）'
        },
        {
          project: '带膜',
          test: '带膜',
          parameter1: '带膜',
          parameter2: '带膜',
          parameter3: '带膜'
        },
        {
          project: 'Pass',
          test: 'Pass',
          parameter1: 'Pass',
          parameter2: 'Pass',
          parameter3: 'Pass'
        }
      ],
      tableData6: [
        {
          project: '压强',
          test: '老化前',
          parameter1: '85℃&85%RH（1000hrs）',
          parameter2: '125℃（1000hrs）'
        },
        {
          project: '1MPa',
          test: '21.7%',
          parameter1: '18.0%',
          parameter2: '19.2%'
        },
        {
          project: '1.5MPa',
          test: '29.1%',
          parameter1: '24.0%',
          parameter2: '25.5%'
        },
        {
          project: '2MPa',
          test: '34.8%',
          parameter1: '28.5%',
          parameter2: '30.0%'
        }
      ]
    },
  },

  // 服务与支持
  serviceSupport: {
    bannerTitle: '服务与支持',
    title: '服务与支持',
    learnMore: '了解详情',
    list: {
      productInfo: '产品基础知识介绍',
      development: '产品开发支持',
      application: '应用支持',
      simulation: '仿真支持',
    },
    // 产品信息页面
    productInfoPage: {
      pageTitle: '产品基础知识介绍',
      breadcrumbService: '服务与支持',
      breadcrumbProductInfo: '产品基础知识介绍',
      tabList: [
        { name: '纳米隔热板产品简介', id: 1 },
        { name: '气凝胶产品简介', id: 2 },
        { name: '导热界面材料（TIM）产品简介', id: 3 },
        { name: '保温材料产品简介', id: 4 }
      ]
    },
    // 产品开发支持页面
    developmentPage: {
      pageTitle: '产品开发支持',
      breadcrumbService: '服务与支持',
      breadcrumbDevelopment: '产品开发支持',
      contentTitle: '产品开发支持',
      contentText: '聚焦前端创新核心，精准对接客户新需求、新材料应用痛点，提供全流程定制化研发协同服务。从需求拆解、市场趋势研判、新材料选型与测试，到配方优化、结构设计、样品快速打样与性能验证，我们配备专业研发团队全程技术对接，打破技术壁垒，助力客户新品快速落地，同时优化产品性能、降低研发成本，提升产品核心竞争力与市场迭代效率，携手客户实现技术创新与产品升级双赢。'
    },
    // 仿真支持页面
    simulationPage: {
      pageTitle: '仿真支持',
      breadcrumbService: '服务与支持',
      breadcrumbSimulation: '仿真支持',
      contentTitle: '仿真支持',
      contentText: '配备专业仿真技术团队与先进仿真工具，提供全维度产品仿真支持服务，提前规避研发与应用风险。可针对产品不同使用场景，开展热学、力学、流体等多维度仿真模拟，精准还原产品在真实工况下的运行状态、性能表现及潜在问题。通过仿真分析优化产品结构设计、材料选型与工艺参数，大幅降低物理试错成本，缩短研发周期，同时确保产品在强度、稳定性、安全性等方面达到行业标准，为产品批量生产与市场投放提供坚实的技术保障。'
    },
    // 应用支持页面
    applicationPage: {
      pageTitle: '应用支持',
      breadcrumbService: '服务与支持',
      breadcrumbApplication: '应用支持',
      contentTitle: '应用支持',
      contentText: '依托丰富的行业应用经验，提供全场景、全方位应用解决方案，同时覆盖多形态产品定制交付，满足不同行业、不同工况的个性化需求。产品形态涵盖大片材、精密模切件、异形件、定制化组合件等，可根据客户具体应用场景优化加工工艺，确保产品适配性。此外，配套提供专业的安装指导、现场技术调试、工艺优化建议，以及后期使用维护答疑，简化客户产品落地流程，解决应用过程中的各类技术难题，保障产品稳定运行。'
    },
    // 产品组件页面
    servicesProduct1: {
      title: '纳米隔热板产品简介',
      definition: '定义',
      definitionContent: '纳米隔热板是基于纳米微孔绝热原理的新型无机板材，以纳米级硅酸钛、SiO₂为原料，经特殊工艺形成亚微米级微孔结构。其导热系数低于静止空气，隔热效果是传统材料的 3-10 倍，可在 400-1200℃稳定工作，能减薄保温层、降低能耗、扩大空间，适配多场景。',
      productIntro: '产品介绍',
      productIntroContent: '内部微孔孔径远小于空气分子自由程，阻断热传导与对流，无机纳米颗粒抑制热辐射，形成 "三重绝热屏障"。100% 无机成分，无有害物质，环保安全。通过原料分散、压制成型、定制加工等步骤加工成型。',
      performanceAdvantage: '性能优势',
      mainProductSystem: '主要产品体系',
      applicationValue: '应用价值',
      applicationValueContent: '以 "材料创新替代空间消耗"，推动工业设备主动降耗，突破传统材料防护极限，助力产品小型化，是低碳与安全升级的核心选择。',
      advantages: [
        {
          title: '极致绝热',
          content: ['常温导热系数低至 0.02W/m-k；', '800℃时 0.040W/m-k；', '节能 10-30%；', '保温层厚度减 50% 以上。']
        },
        {
          title: '环境适配',
          content: ['400-1200℃长期使用；', '1050℃下线收缩率≤2%；', '有硬板、柔性片等形态；', '部分产品憎水、防火A 级。']
        },
        {
          title: '经济环保',
          content: ['寿命 5-10 年；', '是传统材料 2-3 倍；', '1-2 年回收成本；', '纯无机可回收，零污染。']
        }
      ],
      tableColumns: {
        productType: '产品类型',
        keyParams: '键参数',
        applicableScenario: '适配场景'
      },
      tableData: [
        {
          productType: '标准高温隔热板',
          query: '950-1100℃，≤0.04W/m-k',
          applicableScenario: '水泥回转窑、玻璃窑炉'
        },
        {
          productType: '柔性隔热片/毡',
          query: '1000-1200℃，弯曲半径≥5cm',
          applicableScenario: '工业管道、发动机盖'
        },
        {
          productType: '憎水型隔热板',
          query: '1050℃，疏水性≥95%',
          applicableScenario: '燃料电池、潮湿窑炉'
        }
      ]
    },
    servicesProduct2: {
      title: '气凝胶产品简介',
      definition: '定义',
      definitionContent: '气凝胶是经溶胶 - 凝胶法移除液相、保留多孔网络的纳米材料，以气体为分散介质，空气占比 90%-99.8%，孔径 1-100 纳米，孔隙率超 90%，密度最低 0.16mg/cm³，是密度最小的固体之一。',
      productIntro: '产品介绍',
      productIntroContent: '内部微孔孔径远小于空气分子自由程，阻断热传导与对流，无机纳米颗粒抑制热辐射，形成 "三重绝热屏障"。100% 无机成分，无有害物质，环保安全。通过原料分散、压制成型、定制加工等步骤加工成型。',
      performanceAdvantage: '性能优势',
      mainProductSystem: '主要产品体系',
      applicationProspect: '应用前景',
      applicationProspectContent: '气凝胶凭借 "轻、隔热、强韧、吸附" 多维优势，从航空航天高端领域逐步普及至建筑、环保、日常用品等场景。当前面临成本高、加工性待改善等挑战，但随着工艺优化与规模化生产推进，正朝着 "高性能、低成本、绿色化" 发展，未来将在节能减排、高端制造等领域发挥核心作用，成为改变多行业的关键材料。',
      advantages: [
        {
          title: '极致隔热',
          content: ['三重阻断传热（抑制对流、传导、辐射）;', '常温导热系数低至 0.015W/(m・K)，远超传统隔热材料，高低温环境下性能稳定。']
        },
        {
          title: '轻而强韧',
          content: ['密度极低却兼具力学性能，碳气凝胶可承受自身重量数千倍压力，纤维增强型兼具柔性，解决传统气凝胶脆性问题。']
        },
        {
          title: '高效吸附与稳定',
          content: ['比表面积达 500~3000m²/g，对重金属、有机污染物、气体吸附力强且可再生；', '多数类型耐酸耐碱、耐高温氧化，化学稳定性优异。']
        }
      ],
      tableColumns: {
        productType: '类型',
        coreCharacteristics: '核心特性',
        applicationDirection: '应用方向'
      },
      tableData: [
        {
          productType: '硅气凝胶',
          query: '隔热优、成本适中、化学稳定',
          applicableScenario: '建筑 / 管道保温、家电隔热、户外装备'
        },
        {
          productType: '碳气凝胶',
          query: '导电好、强度高、耐高温',
          applicableScenario: '超级电容器、油水分离、高温隔热'
        },
        {
          productType: '金属氧化物气凝胶',
          query: '耐温极强（可达 2000℃+）、催化活性好',
          applicableScenario: '航空发动机隔热、工业窑炉、催化领域'
        },
        {
          productType: '金属氧化物气凝胶',
          query: '环保可降解、柔性等',
          applicableScenario: '医用敷料、柔性电子、复杂场景适配'
        }
      ]
    },
    servicesProduct3: {
      title: '导热界面材料（TIM）产品简介',
      definition: '定义',
      definitionContent: 'TIM 用于填充电子设备发热元件与散热部件的缝隙，排除隔热的空气间隙（空气导热系数仅 0.025W/m-K），降低接触热阻，构建高效热传导通道，保障设备稳定运行、延长寿命。',
      mainTypes: '主要类型',
      performanceParameters: '性能参数',
      selectionPoints: '选型要点',
      tableColumns: {
        productType: '类型',
        typicalForm: '典型形态',
        characteristics: '特点'
      },
      tableData: [
        {
          productType: '导热膏',
          query: '膏状流体（含导热颗粒）',
          applicableScenario: '填充性强、热阻低，需手动涂，无粘性'
        },
        {
          productType: '导热垫片',
          query: '柔性片状（硅胶 / 橡胶基材）',
          applicableScenario: '可预裁切、安装便，有缓冲性，部分带粘性'
        },
        {
          productType: '导热凝胶',
          query: '半流动凝胶状',
          applicableScenario: '自动填缝、无应力，适配不规则界面'
        },
        {
          productType: '导热胶带',
          query: '带胶膜状',
          applicableScenario: '兼具导热与粘接，简化装配'
        },
        {
          productType: '相变材料',
          query: '常温固态，40-80℃熔融',
          applicableScenario: '贴合紧、热阻稳，无泵出'
        },
        {
          productType: '石墨烯垫片',
          query: '柔性片材',
          applicableScenario: '高导热>50W，低热阻'
        },
        {
          productType: '液态金属',
          query: '膏状/片材',
          applicableScenario: '高导热率，低热阻'
        }
      ],
      performanceParams: [
        { 
          title: '导热系数（K）：',
          content: '衡量导热能力，单位 W/m・K，常规 0.5-15W/m・K，高端 20-200W/m・K，实际效果受压力、温度影响。'
        },
        { 
          title: '热阻抗（Rθ）：',
          content: '关键热传递指标，单位℃-cm²/W，优质产品标准压力下≤0.1℃-cm²/W，与流动性、压力等相关。'
        },
        { 
          title: '温度范围：',
          content: '民用 - 40℃至 150℃，工业级 - 55℃至 200℃，需防软化、挥发、开裂。'
        },
        { 
          title: '稳定性：',
          content: '多数需绝缘（体积电阻率≥10¹²Ω・cm），耐老化（1000 小时老化失重≤3%），符合 RoHS、REACH 标准。'
        }
      ],
      selectionCriteria: [
        { 
          title: '热需求：',
          content: '高功率选≥8W/m・K，低功率选 1-3W/m・K；'
        },
        { 
          title: '安装：',
          content: '自动化选导热胶带、预成型垫片，不规则界面选凝胶；'
        },
        { 
          title: '环境：',
          content: '高温选耐高温型，潮湿选耐水解型；'
        },
        { 
          title: '成本：',
          content: '导热系数与成本正相关，平衡性能与预算。'
        }
      ]
    },
    servicesProduct4: {
      title: '保温材料产品简介',
      intro: '在建筑、工业、交通运输等多个领域，保温材料都扮演着至关重要的角色，它不仅能有效节约能源，还能改善环境舒适度，降低生产成本。下面将从保温材料的基本概念、分类、常见类型特点、选择要点以及发展趋势等方面进行详细介绍。',
      tabList: [
        { name: 'first', label: '保温材料的定义与核心作用' },
        { name: 'second', label: '保温材料的分类' },
        { name: 'third', label: '保温材料的选择要点' },
        { name: 'fourth', label: '保温材料的发展趋势' }
      ],
      tab1: {
        definition: {
          title: '定义',
          content: '保温材料，又称绝热材料，是指能阻滞热流传递的材料，通常具有较低的导热系数（一般将导热系数小于 0.05W/(m・K) 的材料称为高效保温材料）。它通过自身特殊的结构，如多孔、纤维状等，减少热量的传导、对流和辐射，从而实现保温或保冷的效果。'
        },
        coreRole: {
          title: '核心作用',
          items: [
            {
              title: '1.节能降耗：',
              content: '在建筑领域，使用保温材料能有效减少建筑物内外的热量交换，降低空调、暖气等设备的能耗，据统计，合理使用保温材料可使建筑能耗降低 30%-50%；在工业生产中，保温材料可用于设备、管道的保温，减少热量损失，提高能源利用率，降低生产成本。'
            },
            {
              title: '2.改善环境舒适度：',
              content: '对于建筑而言，保温材料能维持室内温度的稳定，避免夏季过热、冬季过冷的情况，提升居住和办公的舒适度；在交通工具中，如汽车、火车、飞机等，保温材料可减少外界环境温度对内部空间的影响，为乘客提供更舒适的乘坐体验。'
            },
            {
              title: '3.保护设备与延长使用寿命：',
              content: '工业设备和管道在高温或低温工况下运行时，温度剧烈变化容易对其造成损坏。保温材料能减缓设备和管道的温度变化速度，减少热应力对其的影响，从而保护设备，延长其使用寿命。'
            }
          ]
        }
      },
      tab2: {
        detailIntro: {
          title: '详情介绍',
          content: '根据材质的不同，保温材料主要可分为有机保温材料、无机保温材料和复合保温材料三大类，各类材料在性能、特点和应用场景上存在明显差异。'
        },
        organicMaterials: {
          title: '一、有机保温材料',
          intro: '有机保温材料是以有机高分子化合物为主要成分制成的保温材料，常见的有聚苯乙烯泡沫塑料、聚氨酯泡沫塑料、酚醛泡沫塑料等。',
          items: [
            {
              title: '1.聚苯乙烯泡沫塑料（EPS）：',
              content: '具有质轻、导热系数小、吸水率低、耐冲击等特点，广泛应用于建筑外墙保温、屋面保温、地面保温以及包装领域。但其耐高温性能较差，在高温环境下易收缩、变形，且燃烧时会释放有毒气体，安全性有待提高。'
            },
            {
              title: '2.聚氨酯泡沫塑料（PU）：',
              content: '分为硬泡和软泡两种，硬泡聚氨酯泡沫塑料导热系数极低，保温性能优异，同时具有良好的粘结性和抗压强度，常用于建筑外墙保温、冷库保温、管道保温等；软泡聚氨酯泡沫塑料则具有良好的弹性和舒适性，主要用于家具、床垫、汽车座椅等领域。不过，聚氨酯泡沫塑料同样存在易燃的问题，需要进行阻燃处理。'
            },
            {
              title: '3.酚醛泡沫塑料（PF）：',
              content: '具有优异的耐高温性能、阻燃性能和低烟毒性能，在高温下不熔化、不滴落，燃烧时烟量少，有毒气体释放量低，属于环保型保温材料。其导热系数也较低，保温效果好，适用于高层建筑外墙保温、防火门芯材、电梯井保温等对防火要求较高的场所。但酚醛泡沫塑料脆性较大，抗冲击性能较差，施工过程中容易损坏。'
            }
          ]
        },
        inorganicMaterials: {
          title: '二、无机保温材料',
          intro: '无机保温材料是以无机矿物质为主要成分制成的保温材料，常见的有岩棉、玻璃棉、膨胀珍珠岩、加气混凝土等。',
          items: [
            {
              title: '1.岩棉：',
              content: '以玄武岩、辉绿岩等为主要原料，经高温熔融、纤维化处理制成。具有良好的保温性能、防火性能、隔音性能和化学稳定性，不燃烧、不释放有毒气体，属于 A 级防火保温材料。广泛应用于建筑外墙保温、屋面保温、幕墙保温、管道保温以及工业设备保温等领域。但岩棉的吸水率较高，吸水后保温性能会明显下降，且在施工过程中纤维易脱落，对人体皮肤和呼吸道有一定刺激性，需要做好防护措施。'
            },
            {
              title: '2.玻璃棉：',
              content: '以石英砂、长石、纯碱等为主要原料，经高温熔融、纤维化处理制成。其性能与岩棉相似，具有质轻、导热系数小、防火、隔音等特点，且手感相对柔软，对人体的刺激性较小。主要用于建筑室内保温、隔音，空调管道保温，以及工业设备的保温、隔音等。不过，玻璃棉的耐高温性能不如岩棉，长期使用温度一般不超过 300℃。'
            },
            {
              title: '3.膨胀珍珠岩：',
              content: '以珍珠岩矿石为原料，经破碎、预热、焙烧膨胀而成。具有质轻、多孔、导热系数小、无毒、无味、不燃等特点，可制成珍珠岩保温板、珍珠岩保温砂浆等产品，用于建筑屋面保温、墙面保温、地面保温以及工业窑炉、管道的保温等。但膨胀珍珠岩的吸水率较高，且强度较低，在施工和使用过程中容易破碎。'
            },
            {
              title: '4.加气混凝土：',
              content: '以水泥、石灰、砂、粉煤灰等为主要原料，加入发气剂，经搅拌、浇筑、养护等工艺制成。具有质轻、保温、隔音、防火等特点，同时具有一定的强度，可作为墙体材料使用，实现墙体自保温。广泛应用于多层建筑和高层建筑的非承重墙体、隔墙等。但其导热系数相对有机保温材料和部分无机保温材料略高，保温性能有待进一步提升，且体积收缩率较大，易产生裂缝。'
            }
          ]
        },
        compositeMaterials: {
          title: '三、复合保温材料',
          intro: '复合保温材料是由两种或两种以上不同材质的保温材料，通过一定的工艺复合而成，旨在结合不同材料的优点，弥补单一材料的不足。常见的复合保温材料有岩棉 - 聚苯乙烯复合保温板、玻璃棉 - 聚氨酯复合保温管、无机保温砂浆 - 有机保温板复合体系等。',
          items: [
            {
              title: '1.岩棉 - 聚苯乙烯复合保温板：',
              content: '结合了岩棉的防火性能和聚苯乙烯泡沫塑料的保温性能，既解决了聚苯乙烯泡沫塑料防火性能差的问题，又弥补了岩棉保温性能相对不足的缺点。适用于对保温和防火要求都较高的建筑外墙保温工程。'
            },
            {
              title: '2.玻璃棉 - 聚氨酯复合保温管：',
              content: '以玻璃棉为内芯，聚氨酯泡沫塑料为外层，兼具玻璃棉的良好隔音性能和聚氨酯泡沫塑料的优异保温性能，同时聚氨酯泡沫塑料还能起到防水、防腐的作用。主要用于输送热水、蒸汽等介质的管道保温，尤其适用于地下管道和潮湿环境中的管道保温。'
            },
            {
              title: '3.无机保温砂浆 - 有机保温板复合体系：',
              content: '通常以有机保温板（如聚苯乙烯泡沫板、聚氨酯泡沫板）为保温核心层，外侧涂抹无机保温砂浆。无机保温砂浆具有良好的防火性能和粘结性能，能有效保护有机保温板，提高整个保温体系的防火安全性和抗老化性能，同时也能改善保温体系的外观和施工性能。适用于各类建筑的外墙保温工程，特别是对防火要求较高的建筑。'
            }
          ]
        }
      },
      tab3: {
        detailIntro: {
          title: '详情介绍',
          content: '在选择保温材料时，需要综合考虑多个因素，以确保所选材料能满足实际使用需求，同时达到节能、安全、经济的目的。具体选择要点如下：'
        },
        thermalPerformance: {
          title: '一、保温性能',
          content: '保温性能是保温材料的核心指标，通常用导热系数来衡量，导热系数越小，保温性能越好。在选择时，应根据使用场景的温度要求和节能目标，选择导热系数适宜的保温材料。例如，在低温冷库保温中，需要选择导热系数极低的聚氨酯硬泡保温材料；而在一般建筑的屋面保温中，可选择导热系数相对较小的聚苯乙烯泡沫塑料或岩棉等。'
        },
        firePerformance: {
          title: '二、防火性能',
          content: '防火性能至关重要，尤其是在建筑领域和人员密集场所。根据国家相关标准，建筑保温材料的防火性能分为 A 级（不燃）、B1 级（难燃）、B2 级（可燃）、B3 级（易燃）四个等级。在选择时，应根据建筑的使用性质、高度、防火分区等要求，选择符合相应防火等级的保温材料。例如，高层建筑外墙保温应优先选择 A 级防火保温材料，如岩棉、加气混凝土等；对于多层建筑或非承重墙体保温，可选择 B1 级或 B2 级防火保温材料，但需做好相应的防火构造措施。'
        },
        mechanicalPerformance: {
          title: '三、力学性能',
          content: '力学性能主要包括抗压强度、抗拉强度、抗折强度等，不同的使用场景对保温材料的力学性能要求不同。在建筑外墙保温中，保温材料需要承受自身重量、风荷载以及施工荷载等，因此需要具有一定的抗压强度和抗拉强度，以避免保温层出现开裂、脱落等问题；在地面保温中，保温材料需要承受地面荷载，如人员行走、家具摆放等，因此需要具有较高的抗压强度。'
        },
        weatherResistance: {
          title: '四、耐候性与耐久性',
          content: '保温材料在使用过程中会受到外界环境因素的影响，如温度变化、湿度变化、紫外线照射、雨水冲刷等，因此需要具有良好的耐候性和耐久性，以保证其保温性能和结构稳定性在长期使用过程中不发生明显下降。例如，外墙保温材料需要能够承受夏季高温、冬季严寒以及雨水的侵蚀，同时具有良好的抗老化性能，避免因长期使用而出现开裂、粉化、脱落等现象。'
        },
        environmentalPerformance: {
          title: '五、环保性能',
          content: '随着人们环保意识的提高，保温材料的环保性能也越来越受到关注。在选择时，应选择无毒、无味、无放射性物质释放的保温材料，避免对人体健康和环境造成危害。同时，还应考虑保温材料的可回收利用性，选择可循环利用或易于降解的材料，减少对环境的污染。例如，酚醛泡沫塑料燃烧时烟量少、有毒气体释放量低，属于环保型保温材料；而一些含有有害物质的劣质保温材料，如回收料制成的聚苯乙烯泡沫塑料，不仅保温性能差，还会释放有毒气体，对人体健康和环境危害较大，应避免使用。'
        },
        economicPerformance: {
          title: '六、经济性',
          content: '在满足上述性能要求的前提下，还应考虑保温材料的经济性。保温材料的成本包括材料本身的价格、运输费用、施工费用等。在选择时，应进行综合成本分析，选择性价比高的保温材料。例如，虽然聚氨酯硬泡保温材料的单价相对较高，但其保温性能优异，施工效率高，长期使用能耗低，综合成本可能反而较低；而一些价格低廉的保温材料，如膨胀珍珠岩，虽然单价低，但保温性能相对较差，施工难度大，长期使用可能需要频繁维修更换，综合成本反而较高。'
        }
      },
      tab4: {
        detailIntro: {
          title: '详情介绍',
          content: '随着能源危机的日益加剧和环保意识的不断提高，保温材料行业也在不断发展创新，呈现出以下几个主要发展趋势：'
        },
        highEfficiencyEnergyConservation: {
          title: '一、高效节能化',
          content: '未来的保温材料将更加注重提高保温性能，不断降低导热系数，以实现更高的节能目标。研究人员将通过改进材料的制备工艺、优化材料的微观结构等方式，开发出导热系数更低、保温效果更好的新型保温材料。例如，纳米保温材料通过在材料中引入纳米颗粒或纳米结构，改变材料的热传导特性，从而显著降低导热系数，提高保温性能，有望成为未来高效保温材料的重要发展方向。'
        },
        greenEnvironmentalProtection: {
          title: '二、绿色环保化',
          content: '绿色环保将成为保温材料发展的核心趋势之一。一方面，将更加注重保温材料生产过程的环保性，减少生产过程中的能源消耗和污染物排放，推广使用可再生原料和清洁生产工艺；另一方面，将进一步提高保温材料的使用安全性和环境友好性，开发无甲醛、无异味、无放射性、可降解或可回收利用的环保型保温材料，避免对人体健康和环境造成危害。例如，以农业废弃物（如秸秆、稻壳等）为原料制备的生物质保温材料，不仅来源广泛、成本低廉，还具有良好的环保性能，符合绿色可持续发展的要求。'
        },
        multiFunctionalization: {
          title: '三、多功能化',
          content: '为了满足不同使用场景的多样化需求，保温材料将向多功能化方向发展，除了具备基本的保温性能外，还将集成防火、防水、隔音、抗菌、自清洁等多种功能。例如，开发具有防火、防水、保温一体化功能的外墙保温材料，可简化施工工艺，提高施工效率，同时降低工程成本；开发具有隔音、抗菌功能的室内保温材料，可改善室内居住环境，提升生活品质。'
        },
        lightweightThinning: {
          title: '四、轻量化与薄型化',
          content: '在保证保温性能和力学性能的前提下，保温材料将向轻量化和薄型化方向发展。轻量化的保温材料可减轻建筑结构的荷载，降低建筑成本；薄型化的保温材料可减少保温层的厚度，增加建筑使用面积。例如，通过采用新型的材料复合技术和结构设计，开发出厚度更薄、重量更轻但保温性能优异的保温板材，可广泛应用于建筑外墙保温、屋面保温等领域，尤其适用于对建筑空间要求较高的场所。'
        },
        intelligentization: {
          title: '五、智能化',
          content: '随着智能建筑和智慧城市的发展，保温材料也将逐渐向智能化方向发展。未来的智能保温材料将能够根据外界环境温度、湿度等因素的变化，自动调节自身的保温性能，以实现最佳的节能效果。例如，开发具有温度感应功能的相变保温材料，当环境温度升高时，相变材料吸收热量并发生相变，储存热量；当环境温度降低时，相变材料释放热量并恢复原状，释放热量，从而自动调节室内温度，减少能源消耗。此外，智能保温材料还可与建筑智能化系统相结合，实现远程监控和管理，提高保温系统的运行效率和可靠性。'
        }
      }
    }
  },

  // 联系我们
  contactUs: {
    bannerTitle: '联系我们',
    title: '联系我们',
    zhongshanHQ: '中山总部',
    shanghaiHQ: '上海总部',
    phone: '电话',
    email: '邮箱',
    address: '地址',
    zhongshanPhone: '0760-88166996',
    zhongshanEmail: 'info-am@melonbean.com',
    zhongshanAddress: '广东省中山市火炬开发区街道东利南路5号',
    shanghaiPhone: '18913853555',
    shanghaiEmail: 'info-am@melonbean.com',
    shanghaiAddress: '上海市松江区荣乐东路2369号804室',
    recruit: '招聘岗位',
    urgent: '急',
    publishedAt: '发布于：',
    resumeEmail: '简历投递邮箱：info.asia@melonbean.com，备注官网招聘',
    breadcrumbContact: '联系我们',
    breadcrumbRecruit: '招聘岗位',
    job1: {
      urgent: true,
      name: '普通工人',
      tags: ['上海', '6个月及以上', '本科', '18-55周岁'],
      date: '2025-09-20',
      requirements: '岗位要求：',
      resume: '简历投递：',
      resumeContent: '简历投递邮箱：info.asia@melonbean.com，备注官网招聘',
      sections: [
        {
          title: '一、基本条件',
          content: '年龄18-55 周岁，男女不限，身体健康，无传染性疾病、心脏病、高血压等影响工作的重大疾病，能适应车间常规工作强度。持有有效身份证，信息真实无误，无违法犯罪记录，品行端正，无不良嗜好。具备基础沟通能力，能听懂工作指令，服从车间管理安排，遵守公司各项规章制度。',
        },
        {
          title: '二、岗位能力要求',
          content: '无需相关工作经验，公司提供免费岗前培训，能快速学习并掌握岗位基础操作流程。动手能力强，能熟练使用岗位相关简单工具（如螺丝刀、扳手等），配合完成生产任务。具备基础的责任心，注重工作质量，不敷衍了事，能保证按时完成分配的工作内容。拥有团队协作意识，能与同事配合完成流水线作业或集体工作任务，不单独行动影响生产进度。',
        },
        {
          title: '三、工作纪律要求',
          content: '不无故旷工、迟到、早退，能接受公司的工作时间安排（如单休、两班倒等）。严格遵守考勤制度，遵守安全生产规范，按要求佩戴劳动防护用品（如安全帽、手套、口罩等），不违规操作设备。保持工作区域整洁，不随意堆放杂物，爱护生产设备和工具，节约生产物料。工作期间不做与工作无关的事情（如玩手机、闲聊、离岗等），专注完成工作任务。',
        },
        {
          title: '四、优先录用条件',
          content: '有工厂普工、流水线操作等相关工作经验者优先。能长期稳定工作（6个月及以上），服从岗位调配者优先。做事认真踏实、执行力强，有良好的工作态度者优先。',
        },
      ],
    },
    job2: {
      urgent: true,
      name: '核心工人 / 关键技术岗位操作员',
      tags: ['上海', '男女不限', '3年及以上', '本科及以上'],
      date: '2025-09-20',
      sections: [
        {
          title: '一、岗位职责：',
          items: [
            '负责关键生产工序的日常操作、工艺执行及质量控制',
            '熟练操作本岗位核心设备，确保设备稳定运行及安全生产',
            '按工艺文件、作业指导书完成生产任务，确保产量与良品率',
            '参与生产异常分析与处理，提出改进建议并协助落实',
            '协助新员工培训与现场指导，发挥技术骨干带头作用',
            '配合工艺、质量、设备等部门完成相关改进及审核工作',
            '严格执行安全、5S及公司各项管理制度',
          ],
        },
        {
          title: '二、任职资格：',
          groups: [
            { label: '学历要求：', lines: ['本科及以上学历', '机械制造、机电一体化、自动化、材料、工业工程等相关专业优先'] },
            { label: '经验要求：', lines: ['3年及以上制造型企业一线或技术岗位经验', '有关键工序、核心设备操作经验者优先', '有班组长、技术骨干、师傅带徒经验者优先'] },
            { label: '能力要求：', lines: ['熟悉生产工艺流程，具备较强的实际动手能力', '能独立处理常见生产异常，具备问题分析能力', '责任心强，执行力高，能适应倒班或加班安排', '具备良好的沟通能力和团队协作意识'] },
          ],
        },
        {
          title: '三、岗位能力加分项：',
          items: [
            '熟悉自动化产线或数控设备',
            '参与过工艺改善、降本增效项目',
            '具备基础设备维护或点检能力',
            '有精益生产、TPM、六西格玛相关经验',
          ],
        },
        {
          title: '四、职业发展：',
          items: [
            '核心工人 → 技术骨干 → 班组长 / 工艺技术员',
            '优秀者可向生产管理或技术管理方向发展',
          ],
        },
        {
          title: '五、薪资福利：',
          items: [
            '薪资：面议（核心岗位、能力导向）',
            '五险一金 / 商业保险',
            '年终奖、技能津贴、加班补贴',
            '提供住宿 / 工作餐 / 节假日福利',
          ],
        },
      ],
      resume: '简历投递：',
      resumeContent: '简历投递邮箱：info.asia@melonbean.com，备注官网招聘',
    },
    job3: {
      urgent: true,
      name: '销售代表 / 区域销售专员',
      tags: ['上海', '男女不限', '3年及以上', '本科及以上'],
      date: '2025-09-20',
      sections: [
        {
          title: '一、岗位职责：',
          items: [
            '负责指定区域或行业的市场开拓与客户开发，建立稳定的客户合作体系，达成年度销售目标',
            '维护现有客户关系，定期开展客户回访、需求调研，及时响应客户诉求，提升客户满意度与复购率',
            '精准对接客户需求，制定个性化销售方案，完成报价、谈判、签约等全流程销售工作',
            '跟踪销售订单履约进度，协调内部生产、物流、售后等部门，保障订单顺利交付',
            '收集市场动态、竞品信息及行业政策，形成分析报告，为公司产品优化及营销策略调整提供依据',
            '积极参与公司组织的销售推广活动、展会及行业交流，扩大品牌市场影响力',
            '严格遵守公司销售管理制度，规范填写销售台账，及时回笼货款，确保销售工作合规有序',
          ],
        },
        {
          title: '二、任职资格：',
          groups: [
            { label: '学历要求：', lines: ['本科及以上学历', '材料、化工、电子等相关专业优先'] },
            { label: '经验要求：', lines: ['3年及以上B端/C端销售工作经验，有电子、材料行业销售经验者优先', '具备成熟客户资源、成功开拓市场及达成高业绩目标经验者优先', '有销售团队协作、客户管理或带教新人经验者优先录用'] },
            { label: '能力要求：', lines: ['熟悉销售全流程，具备敏锐的市场洞察力和客户需求挖掘能力', '具备出色的沟通表达、商务谈判及问题解决能力', '目标感强、抗压能力突出，执行力强，能适应出差及阶段性加班安排', '具备良好的职业素养、诚信意识及团队协作精神'] },
          ],
        },
        {
          title: '三、岗位能力加分项：',
          items: [
            '熟悉行业产品知识，具备技术型销售能力或方案式销售经验',
            '有大客户开发与维护、长期合作关系搭建及高客单价订单成交经验',
            '具备基础市场分析、销售策略制定及落地执行能力',
            '持有驾照，能熟练驾驶，且具备丰富跨区域市场拓展经验',
          ],
        },
        {
          title: '四、职业发展：',
          items: [
            '核心路径：销售代表 → 高级销售 → 销售主管 / 区域销售经理',
            '拓展路径：表现优秀者可横向发展至销售管理、市场策划、客户运营等岗位',
          ],
        },
        {
          title: '五、薪资福利：',
          items: [
            '薪资待遇：面议（底薪+高提成+绩效奖金，上不封顶，多劳多得）',
            '基础保障：五险一金 + 商业保险',
            '专项补贴：年终奖、交通补贴、通讯补贴、出差补贴、节日礼金',
            '生活福利：提供工作餐/餐补，定期团建、年度体检，带薪年假',
          ],
        },
      ],
      resume: '简历投递：',
      resumeContent: '简历投递邮箱：info.asia@melonbean.com，备注官网招聘',
    },
    job4: {
      urgent: true,
      name: '工厂IT运维工程师',
      tags: ['上海', '男女不限', '3年及以上', '本科及以上'],
      date: '2025-09-20',
      sections: [
        {
          title: '一、岗位职责：',
          items: [
            '负责工厂服务器、网络设备、工业控制终端及产线相关IT系统（MES/ERP/SCADA等）的日常运维，保障生产全流程IT链路7x24小时稳定运行',
            '制定并执行工厂IT设备巡检、数据备份、漏洞修复及工控系统维护计划，建立运维台账，提前排查生产相关IT风险',
            '快速响应车间产线IT故障、设备告警及员工IT需求，高效完成故障定位、排查与解决，形成故障分析报告',
            '参与工厂IT基础设施扩容、工业网络架构优化，配合产线升级完成MES、SCADA等系统的部署与调试',
            '负责工厂IT运维流程标准化落地，制定工控系统应急预案，协同生产部门优化IT与产线协同效率',
            '配合研发、工艺部门完成新产线导入、系统版本迭代，提供现场IT运维支持',
            '负责工厂IT资产全生命周期管理，落实信息安全及工控安全管理制度',
          ],
        },
        {
          title: '二、任职资格：',
          groups: [
            { label: '学历要求：', lines: ['本科及以上学历', '计算机科学与技术、网络工程、信息安全、工业自动化等相关专业优先'] },
            { label: '经验要求：', lines: ['3年及以上工厂IT运维或工控运维相关工作经验，有制造业IT运维经验者优先', '具备工厂服务器、工业网络、MES/ERP/SCADA等系统运维经验者优先', '有产线IT故障应急处理、跨部门协作经验者优先录用'] },
            { label: '能力要求：', lines: ['熟练掌握Windows/Linux系统运维、企业级网络设备配置，熟悉至少一种工业控制系统基础操作', '具备扎实的计算机网络、工控安全基础知识，能独立排查工厂IT与工控联动故障', '具备较强的生产服务意识与责任心，能适应倒班、加班及突发故障应急处置需求', '具备良好的跨部门沟通能力与团队协作意识'] },
          ],
        },
        {
          title: '三、岗位能力加分项：',
          items: [
            '熟悉PLC基础原理、工业以太网配置，能协助调试工控设备与IT系统接口',
            '有工厂IT运维流程优化、工控安全加固、数据备份方案升级等项目经验',
            '熟悉虚拟化、容器化技术或云平台运维，具备工厂IT资产数字化管理经验',
            '持有阿里云/华为云认证、工控安全认证、软考中级及以上证书',
          ],
        },
        {
          title: '四、职业发展：',
          items: [
            '技术路径：工厂IT运维工程师 → 高级运维工程师 → 工控运维专家 / 工厂IT架构师',
            '管理路径：表现优秀者可横向发展至工厂IT主管、运维经理、智能制造IT负责人等岗位',
          ],
        },
        {
          title: '五、薪资福利：',
          items: [
            '薪资待遇：面议（固定薪资+绩效奖金+生产保障奖金）',
            '基础保障：五险一金 + 商业保险',
            '专项补贴：年终奖、运维津贴、倒班/加班补贴、交通通讯补贴、节日礼金',
            '生活福利：提供工厂宿舍/工作餐，定期团建、年度体检、带薪年假',
          ],
        },
      ],
      resume: '简历投递：',
      resumeContent: '简历投递邮箱：info.asia@melonbean.com，备注官网招聘',
    },
    job5: {
      urgent: true,
      name: '普通销售',
      tags: ['上海', '20-40周岁', '男女不限', '高中及以上学历'],
      date: '2025-09-20',
      sections: [
        {
          title: '岗位要求：',
          groups: [
            {
              label: '一、基本条件',
              lines: ['年龄20-40周岁，男女不限，高中及以上学历，身体健康，无不良嗜好，能适应外出拜访、出差等工作节奏。持有有效身份证件，品行端正，无违法犯罪记录，具备良好的职业道德，严守公司商业机密。具备清晰的语言表达和逻辑思维能力，能精准传达产品专业信息，高效理解客户需求。认同公司企业文化、服从管理安排，遵守公司考勤制度和销售规范，能长期稳定工作。'],
            },
            {
              label: '二、核心岗位要求',
              lines: ['行业经验：具备1年及以上电子行业销售相关经验，熟悉电子产品的市场行情、产品特性及销售模式。', '产品认知：能快速掌握公司产品的核心参数、功能优势及应用场景，针对客户需求提供适配的产品解决方案。', '客户开发：具备基础的客户开拓能力，能通过电话、拜访、行业展会等渠道挖掘潜在客户，积累客户资源。', '销售执行：能独立完成客户对接、需求沟通、报价谈判、订单跟进及售后维护等全流程销售工作，达成个人销售业绩目标。', '工具使用：熟练使用办公软件（Excel、Word、PPT）及微信、企业微信等沟通工具，能规范记录客户信息和销售数据。'],
            },
            {
              label: '三、工作态度与素养',
              lines: ['抗压能力强，能接受销售业绩考核，面对客户拒绝和市场变化能保持积极心态，主动调整销售策略。', '责任心强，对客户需求和订单交付负责，及时响应客户疑问，维护良好的客情关系，提升客户复购率。', '团队协作意识强，能配合团队完成集体销售任务，主动分享行业信息和销售技巧，助力团队业绩提升。', '具备学习能力，主动关注行业技术迭代、市场动态及竞品信息，持续提升自身专业度和销售能力。'],
            },
            {
              label: '四、优先录用条件',
              lines: ['有电子元器件、消费电子、智能家居或工控设备等细分领域销售经验者优先。', '拥有本地电子产品经销商、工厂采购等客户资源者优先。', '具备电子产品技术背景者优先。', '性格开朗外向，亲和力强，擅长商务谈判和客户关系维护者优先。'],
            },
          ],
        },
      ],
      resume: '简历投递：',
      resumeContent: '简历投递邮箱：info.asia@melonbean.com，备注官网招聘',
    },
    job6: {
      urgent: true,
      name: '工厂IT运维工程师',
      tags: ['上海', '22-38周岁', '男女不限', '本科及以上学历'],
      date: '2025-09-20',
      sections: [
        {
          title: '岗位要求：',
          groups: [
            {
              label: '一、基本条件',
              lines: ['年龄22-38周岁，本科及以上学历，计算机、网络工程、自动化等相关专业优先。持有有效身份证件，品行端正，无违法犯罪记录，具备良好的职业道德，严守工厂生产数据、技术参数等核心机密。具备较强的逻辑思维、问题分析与应急处理能力，能快速响应并解决工厂IT系统及设备故障。具备良好的沟通表达和跨部门协作能力，能与生产车间、设备管理、行政后勤等部门高效对接。能适应工厂倒班、应急值守及阶段性加班，抗压能力强。'],
            },
            {
              label: '二、核心岗位要求',
              lines: ['工厂网络运维：熟练掌握TCP/IP协议，能独立完成工厂局域网、车间物联网的搭建、配置与维护；精通路由器、交换机、防火墙等网络设备的调试，能快速排查生产区域网络异常，保障生产数据传输稳定。', '工业设备运维：熟悉工厂工业控制设备（如PLC、工控机、SCADA系统、MES系统）的基础运维，协助解决设备联网、数据采集、系统对接等问题，保障生产设备与IT系统的协同运行。', '服务器与系统运维：熟练操作Linux（CentOS、Ubuntu）和Windows Server操作系统，能完成服务器、数据库的安装、备份、优化及故障处理，保障核心业务系统稳定运行。', '终端设备运维：能快速排查并解决工厂办公电脑、生产终端、打印机、扫码枪等终端设备的故障，确保员工正常办公和生产操作。', '自动化与监控：具备Shell或Python基础脚本编写能力，熟悉Zabbix等监控工具，能搭建工厂IT系统监控体系，实时预警设备故障、系统异常。', '安全管理：了解工业网络安全基础知识，能协助制定工厂IT安全策略，防范病毒攻击、数据泄露等风险，保障生产系统和数据安全。'],
            },
            {
              label: '三、工作经验要求',
              lines: ['具备1-3年及以上工厂/制造业IT运维相关工作经验，熟悉工厂生产流程和工业IT系统架构者优先。', '有过工厂MES系统、ERP系统、仓储管理系统（WMS）的部署、维护或对接经验者优先。', '具备处理工厂生产设备联网故障、系统宕机、数据丢失等应急事件经验者优先。'],
            },
            {
              label: '四、工作态度与素养',
              lines: ['责任心极强，对工厂生产系统的稳定性和数据安全性负责，主动排查潜在技术风险，提前做好故障预防。', '具备持续学习意识，主动关注工业互联网、智能制造等领域的新技术、新工具，不断提升IT运维效率和专业能力。', '严谨细致，在系统配置变更、设备调试、软件升级等工作中严格执行操作流程，避免人为失误。', '具备良好的服务意识，能快速响应车间及各部门的IT需求，耐心提供技术指导，保障生产和办公的顺畅进行。'],
            },
            {
              label: '五、优先录用条件',
              lines: ['持有软考、CCNA/CCNP、工业互联网认证、阿里云ACP等相关专业证书者优先。', '熟悉Docker、Kubernetes等容器化技术，或具备工业大数据、物联网平台运维经验者优先。', '有大型制造工厂运维团队工作经验，或负责过整条生产线IT系统运维者优先。', '具备电气自动化基础，能协助处理工业设备与IT系统对接问题者优先。'],
            },
          ],
        },
      ],
      resume: '简历投递：',
      resumeContent: '简历投递邮箱：info.asia@melonbean.com，备注官网招聘',
    },
    jobs: [
      {
        urgent: true,
        jobName: '普通工人',
        requireList: ['上海', '6个月及以上', '本科'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: '核心工人',
        requireList: ['上海', '3年及以上', '本科及以上'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: '销售代表',
        requireList: ['上海', '3年以上', '本科及以上'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: '工厂IT运维工程师',
        requireList: ['上海', '3年以上', '本科及以上'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: '普通销售',
        requireList: ['上海', '20-40周岁', '高中及以上学历'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: '工厂IT运维工程师',
        requireList: ['上海', '22-38周岁', '本科及以上学历'],
        createDate: '2025-09-20',
      },
    ],
  },
}
